/**
 * useCrypto - Hook for accessing crypto context
 */
import { useContext } from 'react';
import { CryptoContext, CryptoContextType } from '../contexts/CryptoContext';

export function useCrypto(): CryptoContextType {
  const context = useContext(CryptoContext);
  if (!context) {
    throw new Error('useCrypto must be used within a CryptoProvider');
  }
  return context;
}
